import {Injectable} from '@angular/core';
import {DialogParams} from '../models/dialog-param';
import {RoomSetting} from '../models/room-setting';
import {UserSetting} from '../models/user-setting';
import {isNullOrUndefined} from 'util';
import {AuthenticationService} from './authentication.service';
import {Observable, Subject} from 'rxjs/Rx';
import {BackendService} from './backend.service';

@Injectable()
export class SharedValueService {
  private userSession: UserSetting;

  showModal: Subject<DialogParams> = new Subject<DialogParams>();
  httpStatus: Subject<any> = new Subject<any>();
  avatarSubject: Subject<string> = new Subject<string>();
  waitingApiResponse: Subject<boolean> = new Subject<boolean>();
  newEventSubject: Subject<string> = new Subject<string>();

  constructor(private http: BackendService,
              private authService: AuthenticationService) {
  }

  isLoggedIn() {
    return this.authService.isLogin();
  }

  clearUserSession() {
    this.userSession = null;
    this.authService.clearToken();
  }

  set avatar(newAvatar: string) {
    this.userSession.avatar = newAvatar;
    this.avatarSubject.next(newAvatar);
  }

  getAvatar(): Observable<string> {
    return this.avatarSubject.asObservable();
  }

  getHttpStatus(): Observable<any> {
    return this.httpStatus.asObservable();
  }

  getNewEvent(): Observable<string> {
    return this.newEventSubject.asObservable();
  }

  getWaitingApiResponse(): Observable<boolean> {
    return this.waitingApiResponse.asObservable();
  }

  getColorByRoomId(roomId: number, listRooms: RoomSetting[]) {
    return listRooms.filter(item => item.id === roomId)
      .map((obj) => {
        return obj.color;
      });
  }

  getUserSession() {
    if (isNullOrUndefined(this.userSession)) {
      // TO-DO
    }
    return this.userSession;
  }

  fetchUserSession(): Observable<boolean> {
    return Observable.create((subscriber) => {
      this.http.get('/api/auth/auth_user').subscribe((res) => {
        this.userSession = new UserSetting(res['data']);
        subscriber.next(true);
        subscriber.complete();
      }, (error) => {
        subscriber.error(error);
      });
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/services/shared-value.service.ts